import Book2LineIcon from "remixicon-react/Book2LineIcon";
import Addicon from "@mui/icons-material/Add";
import ShoppingBasketLineIcon from "remixicon-react/ShoppingBasketLineIcon";
import TrashLineIcon from "remixicon-react/DeleteBin2LineIcon";

import { useStyles } from "../styles/MaterialNeed.styles";
import { Button, InfoContainer, Modal, Text } from "$components";
import Product from "$containers/Products/Product";
import TableCart from "../components/TableCart";
import DeliveryPicker from "./DeliveryPicker";
import ProductsList from "../components/ProductList";
import ProductImportButton from "../components/ProductImportButton";
import AddProductButton from "../components/AddProductButton";
import IntegratedOrdersTable from "../components/IntegratedOrders/IntegratedOrdersTable";
import AddOrderButton from "../components/AddOrderButton";
import { Loader } from "$components/Layout/Loader";
import { useMaterialNeed } from "../hooks/useMaterialNeed";

type Props = {
  companyId: string | null;
  showCart: boolean;
  isLoading: boolean;
  isAddingMaterial: boolean;
  displayDeliveryModality?: boolean;
  setShowCart: (value: boolean) => void;
  setIsAddingMaterial?: (value: boolean) => void;
};

function MaterialNeed({
  companyId,
  showCart,
  isLoading,
  isAddingMaterial,
  displayDeliveryModality = false,
  setShowCart,
  setIsAddingMaterial,
}: Props) {
  const classes = useStyles();

  const {
    cart,
    integratedOrders,
    dockyardId,
    showEmptyCartModal,
    setShowEmptyCartModal,
    product,
    setProduct,
    handleClickProduct,
    addToCart,
    removeFromCart,
    setIntegratedOrders,
    getTotalArticle,
    handleEmptyCart,
  } = useMaterialNeed();

  // can create components for those, but meh
  // project and folder complexity are already high, no need to over do it
  const rightHeader = (
    <>
      <AddOrderButton
        companyId={companyId || ""}
        dockyardId={dockyardId}
        integratedOrders={integratedOrders}
        isAddingMaterial={isAddingMaterial}
        setIntegratedOrders={setIntegratedOrders}
      />
      <AddProductButton companyId={companyId || ""} addToCart={addToCart} />
      {/* @todo @refacto Import mass component dans un autre ticket */}
      <ProductImportButton companyId={companyId || ""} addToCart={addToCart} />
      <Button
        color="primary"
        onClick={() => {
          setShowCart(true);
          if (getTotalArticle() === 0) {
            setShowCart(false);
            setIsAddingMaterial(false);
          }
        }}
        disabled={!companyId}
      >
        <ShoppingBasketLineIcon />
        {`Panier (${getTotalArticle()})`}
      </Button>
    </>
  );

  const renderProductListView = (
    <div>
      <InfoContainer
        leftHeader={
          <>
            <Book2LineIcon />
            <Text type="h3" className={classes.title}>
              Besoin en matériel
            </Text>
          </>
        }
        customClassRightHeader={classes.materielRightHeader}
        customClassHeader={classes.materielHeader}
        rightHeader={rightHeader}
      >
        {!companyId ? (
          <Text>
            Veuillez sélectionner une entreprise (projet/chantier) pour ajouter
            du matériel.
          </Text>
        ) : isLoading ? (
          <Loader />
        ) : (
          <ProductsList
            companyId={companyId}
            addToCart={addToCart}
            cart={cart}
            handleClickProduct={handleClickProduct}
          />
        )}
      </InfoContainer>
    </div>
  );

  const renderCartView = (
    <div>
      <InfoContainer
        leftHeader={
          <>
            <ShoppingBasketLineIcon />
            <Text
              type="h3"
              className={classes.title}
            >{`Produits dans le panier (${getTotalArticle()})`}</Text>
          </>
        }
        customClassRightHeader={classes.materielRightHeader}
        customClassHeader={classes.materielHeader}
        rightHeader={
          <>
            <Button
              variant="outlined"
              color="primary"
              style={{ textTransform: "none", marginRight: 20 }}
              onClick={() => setShowEmptyCartModal(true)}
              className={classes.textButton}
            >
              <TrashLineIcon />
              <span>Vider le panier</span>
            </Button>
            <Button color="primary" onClick={() => setShowCart(false)}>
              <Addicon />
              <span>Ajouter produits</span>
            </Button>
          </>
        }
      >
        <div className={classes.cartContent}>
          {cart.length > 0 && (
            <TableCart
              companyId={companyId || ""}
              removeFromCart={removeFromCart}
              addToCart={addToCart}
              cart={cart}
              handleClickProduct={handleClickProduct}
            />
          )}
          {isLoading ? (
            <Loader />
          ) : (
            <IntegratedOrdersTable
              handleClickProduct={handleClickProduct}
              integratedOrders={integratedOrders}
              setIntegratedOrders={setIntegratedOrders}
            />
          )}
        </div>
      </InfoContainer>
      <Modal
        open={showEmptyCartModal}
        onValidate={handleEmptyCart}
        title="Confirmation de suppression"
        textValidate="Vider"
        isLoading={false}
        onCancel={() => setShowEmptyCartModal(false)}
      >
        <div className={classes.dialogContent}>
          <Text>
            Vous êtes sur le point de vider entièrement votre panier.
            Souhaitez-vous continuer ?
          </Text>
        </div>
      </Modal>
    </div>
  );

  if (displayDeliveryModality) {
    return (
      <div>
        <DeliveryPicker edbCompanyId={companyId} />
      </div>
    );
  }

  return (
    <div>
      {showCart ? renderCartView : renderProductListView}
      <Product
        companyId={companyId || ""}
        resetProduct={() => {
          setProduct(undefined);
        }}
        addToCart={addToCart}
        cart={cart}
        product={product?._id ? product : undefined}
      />
    </div>
  );
}

export default MaterialNeed;
